import styled from 'styled-components';
import { Breakpoints } from '../../../styled/constants';
import { FlexCenteredColumn } from '../../../styled/common';
import { PlaceholderBlock } from '../../../styled/placeholders.styled';

export const CurrentItemPlaceholderLayout = styled.div`
  @media (min-width: ${Breakpoints.desktop}px) {
    width: 1000px;
    margin: auto;
  }
`;

export const CurrentItemPlaceholderContent = styled.div`
  background-color: ${({ theme }) => theme.colors.background.tertiary};

  @media (min-width: ${Breakpoints.tablet}px) {
    background-color: ${({ theme }) => theme.colors.background.primary};
    padding: 0 40px;
  }

  @media (min-width: ${Breakpoints.smallDesktop}px) {
    display: grid;
    grid-template-columns: 2fr 1fr;
    gap: 20px;
  }

  @media (min-width: ${Breakpoints.desktop}px) {
    padding: 0 20px;
  }
`;

export const CurrentItemSection = styled(FlexCenteredColumn)`
  background-color: ${({ theme }) => theme.colors.background.primary};
  border-radius: 14px;
  padding: 20px;
  margin-bottom: 5px;
  gap: 15px;

  @media (min-width: ${Breakpoints.tablet}px) {
    border-radius: 0;
    padding: 20px 0;
  }

  @media (min-width: ${Breakpoints.smallDesktop}px) {
    padding: 0;
    gap: 0;
  }
`;

export const DescriptionPlaceholder = styled(PlaceholderBlock)`
  @media (min-width: ${Breakpoints.smallDesktop}px) {
    height: 191px;
    margin-top: 30px;
    margin-bottom: 30px;
  }
`;

export const MapPlaceholder = styled(PlaceholderBlock)`
  @media (min-width: ${Breakpoints.smallDesktop}px) {
    height: 131px;
    margin-bottom: 30px;
  }
`;

export const LocationsPlaceholder = styled(PlaceholderBlock)`
  @media (min-width: ${Breakpoints.smallDesktop}px) {
    height: 44px;
  }
`;

export const StatisticPlaceholder = styled(PlaceholderBlock)`
  @media (min-width: ${Breakpoints.smallDesktop}px) {
    display: none;
  }
`;

export const MainInfoPlaceholder = styled(PlaceholderBlock)`
  @media (min-width: ${Breakpoints.smallDesktop}px) {
    height: 490px;
    margin-bottom: 15px;
  }
`;

export const ManagementPlaceholder = styled(PlaceholderBlock)`
  @media (min-width: ${Breakpoints.smallDesktop}px) {
    height: 52px;
  }
`;
